<template>
  <div>
    <div ref="editPlanTop" class="absolute target-top"></div>
    <div v-show="!showMapPanel" class="plan">
      <condition />
      <course :editable=editable @openMap="openMap" />
      <plan-price />
      <control ref="control" :planId="id" />
      <new-plan-modal v-show="modal.show">
        <new-plan-input :course="course" :place="place" @search="search" :closeModal="() => closeModal()" />
      </new-plan-modal>
    </div>
    <div v-show="showMapPanel" class="relative z-10">
      <map-detail @closeMap="closeMap"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Condition from '../components/organisms/Condition'
import Course from '../components/organisms/Course'
import Control from '../components/organisms/Control'
import PlanPrice from '../components/organisms/PlanPrice'
import NewPlanModal from "../components/molecules/NewPlanModal"
import NewPlanInput from '../components/molecules/NewPlanInput'
import MapDetail from "../components/molecules/MapDetail"
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  components: {
    Condition,
    Course,
    Control,
    PlanPrice,
    NewPlanModal,
    NewPlanInput,
    MapDetail
  },
  props: {
    courseId: {
      type: String
    },
    poiId: {
      type: String
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      editable: true,
      course: {},
      place: {},
      modal: {
        show: false
      },
      showMapPanel: false
    }
  },
  mounted () {
    if (this.courseId) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('courses/fetchCourseDetail', this.courseId)
        .then(() => {
          this.course = this.courseDetail
          this.modal.show = true
        })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    } else if (this.poiId) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('places/fetchPlace', this.poiId)
        .then((p) => {
          this.place = {
            name: p.shop_name,
            yomi: p.shop_name_yomi,
            detail: p.shop_introduction,
            image: (p.images && p.images.length > 0) ? p.images[0].url : '',
            location: {
              latitude: p.latitude,
              longitude: p.longitude
            },
            visit: 60
          }
          this.modal.show = true
        })
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    } else {
      this.$refs.control.setBackAlert()
    }
  },
  methods: {
    search () {
      this.modal.show = false
      if (this.courseId) {
        this.$store.dispatch('condition/resetDetailOptions')
        this.$store.dispatch('destinations/buildDestinations', this.course.places)
        this.$store.dispatch('plans/updateTitle', this.course.title)
        this.$store.dispatch('routes/search')
        this.$refs['editPlanTop'].scrollIntoView({ behavior: 'smooth'})
        this.$refs.control.setBackAlert()
      } else if (this.place) {
        this.$store.dispatch('condition/resetDetailOptions')
        this.$store.dispatch('destinations/buildDestinations', [this.place])
        this.$store.dispatch('plans/updateTitle', this.place.shop_name)
        this.$store.dispatch('routes/search')
        this.$refs['editPlanTop'].scrollIntoView({ behavior: 'smooth'})
        this.$refs.control.setBackAlert()
      }
    },
    openMap: function () {
      this.showMapPanel = true
      this.$refs.control.updateShowMapPanel(true)
    },
    closeMap: function () {
      this.showMapPanel = false
      this.$refs.control.updateShowMapPanel(false)
    }
  },
  computed: {
    ...mapGetters({
      routes: 'routes/getAll',
      courseDetail: 'courses/getCourseDetail'
    })
  }
}
</script>
